module.exports = (__webpack_require__("dll-reference vue3_library_v5"))("v");